import * as DialogPrimitive from '@radix-ui/react-dialog';
import { ForwardedRef } from 'react';

export function DialogModalClose(
	{ children, ...rest }: DialogPrimitive.DialogCloseProps,
	ref: ForwardedRef<HTMLButtonElement>,
): JSX.Element {
	return (
		<DialogPrimitive.Close {...rest} ref={ref}>
			{children}
		</DialogPrimitive.Close>
	);
}
